import * as React from "react"

export default function Footer() {
  return <footer>&copy; Jeffrey Schmit 2021</footer>;
}
